import React from 'react';
import styled from 'styled-components';
import { black600, blue300 } from '../theme/colors';
import { baseCaption } from '../theme/typography';
import CheckBox from './ui/CheckBox';

const ChecKBoxListStyle = styled.ul`
    width: 100%;
    padding: 0 16px 10px 16px;
    box-sizing: border-box;
    color: ${black600};
    position: relative;
    overflow-y: auto;
    margin: 0;
    max-height: 200px;
    transition: all 0.4s;
    cursor: pointer;
    list-style: none;
    li {
        list-style: none;
        margin-top: 10px;
        cursor: pointer;
        &:first-child {
            margin-top: 4px;
        }
        &:last-child {
            margin-bottom: 4px;
        }
    }
`;

const CheckBoxList = ({filterName='',options=[],checkedList=[],onChangeFilterValue=()=>{}, labelKey = 'name', valueKey = 'id'}) => {
    return(
        <ChecKBoxListStyle key={filterName} id='filter-overflow'>
            {options.map((opt, index) => {
                const isChecked = (checkedList || []).includes(opt[valueKey]);

                return (
                    <li key={`${index}`} className={isChecked ? 'checked' : ''}>
                        <CheckBox
                            name={filterName}
                            checked={isChecked}
                            label={opt[labelKey]}
                            background={blue300}
                            onChange={(event) => {
                                onChangeFilterValue({ event, target: opt[valueKey] })
                            }}
                        />
                    </li>
                )
            })}
        </ChecKBoxListStyle>
    )
}

export default CheckBoxList;